import { formatPlural } from '@lbcamden/shared-utils';

import { maxUserPinFailureCount } from '~/common/config/constants';

export const getPinFailureErrorMessage = (failureCount: number) => {
  if (!failureCount) {
    return '';
  }
  if (failureCount === maxUserPinFailureCount) {
    return 'Failure limit reached. PIN must be reset.';
  }
  const remainingAttempts = maxUserPinFailureCount - failureCount;
  let message = `Incorrect PIN entered. ${remainingAttempts} ${formatPlural('attempt', remainingAttempts)} remaining.`;

  if (failureCount === maxUserPinFailureCount - 1) {
    message +=
      '\nIf you enter an incorrect PIN again, you will need to sign in with your Camden account and reset your PIN.';
  }
  return message;
};
